import { render, staticRenderFns } from "./UsersPageNew.vue?vue&type=template&id=b19a3428&"
import script from "./UsersPageNew.vue?vue&type=script&lang=js&"
export * from "./UsersPageNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports